import React, { FC, ReactElement } from 'react';
import { ApolloClient, ApolloConsumer } from '@apollo/client';

import { WizardPage } from '@buyside/components/presentation/Form/Wizard/Wizard';
import { WizardContextProps } from '@interfaces/wizard/wizard';
import Information from './Information';
import { informationSchema } from '@buyside/components/presentation/UserApplication/Helpers/validations';

import { debounce } from '@buyside/util/lodashAlt';

import { EmailSearchQuery, EmailSearchDocument, Maybe } from '@interfaces/graphql-typings';

const InformationContainer: FC<{
  isLoading: boolean;
  isRobot: boolean;
  validationSchema: typeof informationSchema;
}> = ({ validationSchema, isLoading, isRobot }): ReactElement => {
  return (
    <ApolloConsumer>
      {(client: ApolloClient<any>): ReactElement => {
        const checkIfEmailExists = debounce((value: Maybe<string>): Promise<
          string | EmailSearchQuery
        > => {
          let error: string;
          const emailSearchQuery = async (
            value: Maybe<string>
          ): Promise<string | EmailSearchQuery> => {
            return client
              .query<
                EmailSearchQuery,
                {
                  email: Maybe<string>;
                }
              >({
                query: EmailSearchDocument,
                variables: { email: value }
              })
              .then(({ data: { emailSearch } }): string => {
                if (emailSearch) {
                  error = 'This email has been taken.';
                }
                return error;
              });
          };
          return emailSearchQuery(value);
        }, 400);
        return (
          <WizardPage validationSchema={validationSchema}>
            {({ setFieldValue, initialValues }: WizardContextProps): ReactElement => (
              <Information
                setFieldValue={setFieldValue}
                checkIfEmailExists={checkIfEmailExists}
                isLoading={isLoading}
                isRobot={isRobot}
                initialValues={initialValues}
              />
            )}
          </WizardPage>
        );
      }}
    </ApolloConsumer>
  );
};

export default InformationContainer;
